/* eslint-disable no-shadow */

import { ActionTree, GetterTree, MutationTree, Module } from 'vuex';
import { setupApollo } from '../../../lib/apollo_setup';
import { FETCH_ACCOUNT_DATA } from '@/graphql/account/queries';
import { Account, AccountData } from '../../../models/account';
import { rolesArray } from '@/lib/jwt';

export interface AccountState {
  account: Account | null;
  error: string | null;
}

const apolloProvider = setupApollo();

const state: AccountState = {
  account: null,
  error: null,
};

const getters: GetterTree<AccountState, any> = {
  isAuthenticated: (state): boolean => !!state.account,
  getAccount: (state): Account | null => state.account,
  getZipCode: (state): string | null => state.account?.location.zipcode || null,
};

const mutations: MutationTree<AccountState> = {
  setAccount(state, account: Account) {
    state.account = account;
  },
  setError(state, error: string) {
    state.error = error;
  },
};

const actions: ActionTree<AccountState, any> = {
  async fetchAccountData({ commit }) {
    try {
      const result = await apolloProvider.defaultClient.query({
        query: FETCH_ACCOUNT_DATA,
      });

      const accountData = result.data.viewer;
      if (!accountData) {
        window.location.href = '/login';
        return;
      }

      const account = new Account({
        ssoUUID: accountData.id,
        id: accountData.id,
        firstName: accountData.firstName,
        lastName: accountData.lastName,
        email: accountData.email,
        originalPhoto: accountData.photoUrl,
        croppedPhoto: accountData.photoUrl,
        location: {
          latitude: parseFloat(accountData.location.geoPoint.y),
          longitude: parseFloat(accountData.location.geoPoint.x),
          zipcode: accountData.location.zipcode,
        },
        hasPremiumHistory: accountData.hasPremiumHistory,
        profilePhotoStatus: accountData.profilePhotoStatus,
        roles: rolesArray(),
      } as AccountData);

      commit('setAccount', account);
    } catch (error) {
      commit('setError', 'Failed to fetch account data.');
      window.location.href = '/login';
    }
  },
};

const accountModule: Module<AccountState, any> = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};

export default accountModule;
